import { Classificatiecollectie, Identifier, Titelcollectie } from "../models";
import { Documenthandelingen, DocumentMetadata, Documentrelaties, Geldigheid } from "../models/document-metadata";

interface CreateMetadataInput {
  publisher: Identifier;
  identifiers: string[];
  language: Identifier;
  titelcollectie: Titelcollectie;
  classificatiecollectie: Classificatiecollectie;
  documenthandelingen: Documenthandelingen[];
  publicatiebestemming: string[];

  creatiedatum?: string;
  verantwoordelijke?: Identifier;
  naamOpsteller?: string;
  omschrijvingen?: string[];
  format?: Identifier;
  onderwerpen?: string[];
  aggregatiekenmerk?: string;
  documentrelaties?: Documentrelaties[];
  geldigheid?: Geldigheid;
  pid?: string;
}

export class MetadataFactory {
  public create = (input: CreateMetadataInput): DocumentMetadata => {
    return {
      document: {
        publisher: input.publisher,
        identifiers: input.identifiers,
        language: input.language,
        titelcollectie: input.titelcollectie,
        classificatiecollectie: input.classificatiecollectie,
        documenthandelingen: input.documenthandelingen,
        publicatiebestemming: input.publicatiebestemming,

        creatiedatum: input.creatiedatum,
        verantwoordelijke: input.verantwoordelijke,
        naamOpsteller: input.naamOpsteller,
        omschrijvingen: input.omschrijvingen,
        format: input.format,
        onderwerpen: input.onderwerpen,
        aggregatiekenmerk: input.aggregatiekenmerk,
        geldigheid: input.geldigheid,
        pid: input.pid,
      },
      documentrelaties: input.documentrelaties ?? [],
    };
  };
}
